import React,{ useState } from "react";
import useStyles from 'isomorphic-style-loader/useStyles'
import classes from './style.module.scss'
import { useMemo } from "react";
import { FormattedMessage } from "react-intl";
import { useCallback } from "react";
import { useEffect } from "react";
import { BigButton } from "../../../../../../components/button";
import { IMAGE_GEEKO_LTD } from "../../../../../../../../constants";
import JSZip from 'jszip'
import { setOPLoading } from "../../../../../../../../store/actions/ui";
import { useDispatch, useSelector } from "react-redux";

const ModelStature = props =>{
    const { modelStature } = props;
    
    return <div className={classes.ModelStature}>
        <div className={classes.Image} style={{background:`url(${modelStature.image}) center top/cover`}}></div>
        <div className={classes.SizeContainer}>
            <div>
                <span className={classes.Title1}><FormattedMessage id="model_wear" defaultMessage="Model Wear" />: </span>
                <span className={classes.Title2}>{modelStature?.wear}</span>
            </div>
            <div className={classes.Content}>
                {
                    modelStature?.height && <div>
                        <span className={classes.Title1}><FormattedMessage id="height" defaultMessage="Height" />: </span>
                        <span className={classes.Title2}>{modelStature.height}cm</span>
                    </div>
                }

                {
                    (modelStature?.bust || modelStature?.breast) && <div>
                        <span className={classes.Title1}><FormattedMessage id="bust" defaultMessage="Bust" />: </span>
                        <span className={classes.Title2}>{modelStature.bust || modelStature.breast}cm</span>
                    </div>
                }

                {
                    modelStature?.waist && <div>
                        <span className={classes.Title1}><FormattedMessage id="waist" defaultMessage="Waist" />: </span>
                        <span className={classes.Title2}>{modelStature.waist}cm</span>
                    </div>
                }

                {
                    modelStature?.hip && <div>
                        <span className={classes.Title1}><FormattedMessage id="hips" defaultMessage="Hips" />: </span>
                        <span className={classes.Title2}>{modelStature.hip}cm</span>
                    </div>
                }
            </div>
        </div>
    </div>
}

const ModelSizeMessage = props =>{
    const { modelListOnCm, modelListOnInch, modelNote } = props;
    const [modelData,setModelData] = useState(modelListOnCm);
    const [currentCM,setCurrentCM] = useState(true);

    const checkBoxEvent = (flag) =>{
        let data = flag?modelListOnCm:modelListOnInch;
        setModelData(data);
        setCurrentCM(flag);
    }

    let unit = useMemo(()=>{
        return currentCM?"cm":"inch";
    },[currentCM]);
    return <div className={classes.ModelSizeMessage}>
        {
            (modelListOnCm?.length > 0 || modelListOnInch?.length > 0) && <React.Fragment>
                <div className={classes.ModelCheckbox}>
                    <span className={`${classes.Item}`}>
                        <span className={`${classes.CheckBox} ${currentCM?classes.Active:""}`} onClick={()=>checkBoxEvent(true)}></span>
                        <span>cm</span>
                    </span>

                    <span className={`${classes.Item} ${classes.Inch}`}>
                        <span  className={`${classes.CheckBox} ${!currentCM?classes.Active:""}`} onClick={()=>checkBoxEvent(false)}></span>
                        <span>Inch</span>
                    </span>
                </div>

                <div className={classes.Modeltable}>
                    <table>
                        <thead>
                            <tr>
                                <td><FormattedMessage id="model" defaultMessage="Model" /></td>
                                <td><FormattedMessage id="height" defaultMessage="Height" /></td>
                                <td>BWH</td>
                                <td><FormattedMessage id="size_guide" defaultMessage="Size Guide" /></td>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                modelData.map((model,index) =>{
                                    return <tr key={index}>
                                        <td>{model.name}</td>
                                        <td>{model.height}</td>
                                        <td>{model.bust}/{model.waist}/{model.hip}({unit})</td>
                                        <td>{model.wear}</td>
                                    </tr>
                                })
                            }
                        </tbody>
                    </table>
                </div>
            </React.Fragment>
        }
        
        {
            modelNote && <div className={classes.ModelNote}>
                {modelNote}
            </div>
        }
        
    </div>
}

const ModelStatureItem = props =>{
    const { productHooks, modelToggle, changeModelToggle } = props;
    const { selectedProduct } = productHooks;

    return <div className={classes.Item}>
        <div className={`${classes.Hd} ${classes.ModelStatureHd} ${modelToggle?classes.Active:""}`} onClick={()=>changeModelToggle()}>
            <span className={classes.Title}><FormattedMessage id="model_stature" defaultMessage="Model Stature" /></span>
            <span className={classes.Icon}></span>
        </div>

        <div className={`${classes.Bd} ${classes.ModelStatureBd} ${modelToggle?classes.Active:""}`}>
            {
                selectedProduct?.modelStature?.imageModel && <ModelStature modelStature={selectedProduct.modelStature.imageModel} />
            }
            
                
            <ModelSizeMessage 
                modelListOnCm={selectedProduct.modelStature?.modelListOnCm} 
                modelListOnInch={selectedProduct.modelStature?.modelListOnInch}
                modelNote={selectedProduct.modelStature?.note}
            />
        </div>
    </div>
}

const DetailItem = props =>{
    const { productHooks, detailToggle, changeDetailToggle } = props;
    const { selectedProduct } = productHooks;

    const getDescription = useCallback(desc => {
        try {
            return desc?.replace(/font-size:\s*\d*.?\d*rem/g, '')?.replace(/(<b[^>]*>.*?<font\s+[^>]*\bface=")tahoma(".*?<\/font>.*?<\/b>)/g, '$1Roboto-Medium$2').replace('tahoma', 'Roboto').replace(/(<[^>]+?style=".*?)font-size\s*:\s*[^;"']*;?(.*?)"/g, '$1$2"').replace(/<font[^>]*\ssize="[^"]*"/g, '<font')?.replace(/white-space: pre;/g, '')?.replace(/white-space:pre;/g, '')
        } catch (error) {
            return desc
        }
    }, [])

    useEffect(()=>{
        changeDetailToggle();
    },[]);
    
    return <div className={classes.Item}>
        <div className={`${classes.Hd} ${classes.DetailItemHd} ${detailToggle?classes.Active:""}`} onClick={()=>changeDetailToggle()}>
            <span className={classes.Title}><FormattedMessage id="product_details" defaultMessage="Product Details" /></span>
            
            {
                selectedProduct?.descriptionModel && <div className={classes.Tips}>
                    {
                        selectedProduct?.descriptionModel?.material && <span>#{selectedProduct?.descriptionModel?.material}</span>
                    }

                    {
                        selectedProduct?.descriptionModel?.fitType && <span>#{selectedProduct?.descriptionModel?.fitType}</span>
                    }
                </div>
            }

            <span className={classes.Icon}></span>
        </div>

        <div className={`${classes.Bd} ${classes.ModelStatureBd} ${detailToggle?classes.Active:""}`}>
            {
                detailToggle && selectedProduct?.description2 && <div>
                    <div dangerouslySetInnerHTML={{__html:getDescription(selectedProduct?.description2)}}></div>
                </div>
            }
        </div>
    </div>
}

const BeautyIngredients = props =>{
    const { selectedProduct } = props;
    const [toggle,setToggle] = useState(false);

    return <div className={classes.Item}>
        <div className={`${classes.Hd} ${classes.DetailItemHd} ${toggle?classes.Active:""}`} onClick={()=>setToggle(state=>!state)}>
            <span className={classes.Title}><FormattedMessage id="ingredients" defaultMessage="Ingredients" /></span>
            <span className={classes.Icon}></span>
        </div>

        <div className={`${classes.Bd} ${classes.ModelStatureBd} ${toggle?classes.Active:""}`}>
            {
                toggle && selectedProduct?.beautyIngredients && <div>
                    <div dangerouslySetInnerHTML={{__html:selectedProduct?.beautyIngredients}}></div>
                </div>
            }
        </div>
    </div>
}

const DownloadProductImages = props =>{
    const { productVO, selectedProduct } = props;
    const { products } = productVO;
    const [toogle, setToogle] = useState(false);
    const dispatch = useDispatch();

    const images = useMemo(() =>{
        return products?.map(product=>(`/image.chic-fusion.com/large/${product?.pcMainImage}`));
    }, [products]);

    const downLoadImage = useMemo(() =>{
        return selectedProduct?.pcMainImage;
    }, []);

    const handleDownloadOne = useCallback((imageUrl, fileName) =>{
        const canvas = document.createElement('canvas');
        const context = canvas.getContext('2d');

        const image = new Image();
        image.crossOrigin = 'anonymous'; // 设置图片跨域属性
        image.src = imageUrl;

        dispatch(setOPLoading(true));
        image.onload = () => {
            canvas.width = image.width;
            canvas.height = image.height;
            context.drawImage(image, 0, 0);

            // 将绘制的图像转换为数据URL
            const dataUrl = canvas.toDataURL('image/jpeg');

            // 创建临时下载链接并触发下载
            const link = document.createElement('a');
            link.href = dataUrl;
            link.download = fileName;
            link.click();
            dispatch(setOPLoading(false));
        };
    }, []);

    const handleDownloadImages = useCallback((imageUrls) =>{
        const zip = new JSZip();
        dispatch(setOPLoading(true));

        // 创建一个Promise数组来保存下载每张图片的Promise
        const downloadPromises = imageUrls.map((url, index) => {
            return new Promise((resolve) => {
                const img = new Image();
                img.crossOrigin = 'Anonymous';
                
                img.onload = () => {
                    const canvas = document.createElement('canvas');
                    const ctx = canvas.getContext('2d');
                    canvas.width = img.width;
                    canvas.height = img.height;
                    ctx.drawImage(img, 0, 0);

                    // 将canvas生成的base64图片链接添加到压缩包中
                    const base64DataUrl = canvas.toDataURL('image/jpeg');
                    const fileName = `image${index + 1}.jpg`;
                    zip.file(fileName, base64DataUrl.split(',')[1], { base64: true });

                    resolve();
                };

                img.onerror = () =>{
                    resolve();
                }

                img.src = url;
            });
        });

        // 等待所有图片下载完成后生成压缩包并触发下载
        Promise.all(downloadPromises).then(() => {
            zip.generateAsync({ type: 'blob' }).then((content) => {
                // 创建一个临时的URL对象，用于设置下载链接的href
                const zipUrl = URL.createObjectURL(content);

                // 创建一个隐藏的<a>元素来触发下载
                const downloadLink = document.createElement('a');
                downloadLink.href = zipUrl;
                downloadLink.download = 'images.zip';

                // 触发下载
                downloadLink.click();

                // 释放临时的URL对象
                URL.revokeObjectURL(zipUrl);

                dispatch(setOPLoading(false));
            });
        });
    }, []);

    
    return <div className={classes.Item}>
        <div className={`${classes.Hd} ${classes.DownloadHd} ${toogle?classes.Active:""}`} onClick={()=>setToogle(state=>!state)}>
            <span className={classes.Title}><FormattedMessage id="download_products_images" defaultMessage="Download Product's Images" /></span>
            
            <span className={classes.Icon}></span>
        </div>

        <div className={`${classes.Bd} ${classes.DownloadBd} ${toogle?classes.Active:""}`}>
            {
                images?.length > 1 && <div className={`${classes.Download} ${classes.MarginBottom8}`}>
                    <div className={classes.Image}>
                        <img src={`${IMAGE_GEEKO_LTD}/small/${downLoadImage}` || ""} alt="" />
                    </div>

                    <div className={classes.ClickContainer}>
                        <span className={classes.Font}><FormattedMessage id="download_all" defaultMessage="Download All" /></span>

                        <BigButton 
                            className={classes.Button} 
                            onClick={()=>handleDownloadImages(images)}
                        >
                            <React.Fragment>
                                <span><FormattedMessage id="download" defaultMessage="Download" /></span>
                                <span className={classes.DIcon}></span>
                            </React.Fragment>
                        </BigButton>
                    </div>
                </div>
            }
            
            {
                products?.map((product, index) =>(
                    <div className={`${classes.Download} ${index > 0 ? classes.MarginTop8 : ""}`} key={product?.id+index}>
                        <div className={classes.Image}>
                            <img src={`${IMAGE_GEEKO_LTD}/small/${product?.pcMainImage}`} alt="" />
                        </div>

                        <div className={classes.ClickContainer}>
                            <span className={classes.Font}>Sku: {product?.parentSku}</span>

                            <BigButton 
                                className={classes.Button} 
                                onClick={()=>handleDownloadOne(`/image.chic-fusion.com/large/${product?.pcMainImage}`, product?.pcMainImage)}
                            >
                                <React.Fragment>
                                    <span><FormattedMessage id="download" defaultMessage="Download" /></span>
                                    <span className={classes.DIcon}></span>
                                </React.Fragment>
                            </BigButton>
                        </div>
                    </div>
                ))
            }
        </div>
    </div>
}

const ProductDetailAndModel = props =>{
    useStyles(classes);
    const { productHooks } = props;
    const { selectedProduct, isBeautyMakeup, productVO } = productHooks;
    const [modelToggle,setModelToggle] = useState(false);
    const [detailToggle,setDetailToggle] = useState(false);
    const global = useSelector(state=>state.global);
    const pageCustomer = useSelector(state=>state.pageCustomer);
    const { customer } = pageCustomer;
    const { config } = global;

    const modelToggleEvent = () =>{
        setModelToggle(state=>!state);
        detailToggle && setDetailToggle(false)
    }

    const detailToggoleEvent = () =>{
        setDetailToggle(state=>!state);
        modelToggle && setModelToggle(false)
    }

    return <div className={classes.ProductDetailAndModel}>
        {
            selectedProduct?.modelStature?.modelListOnCm?.length > 0 && <React.Fragment>
                <ModelStatureItem 
                    productHooks={productHooks} 
                    modelToggle={modelToggle}
                    changeModelToggle={()=>modelToggleEvent()}
                />
            </React.Fragment>
        }
        
        <DetailItem 
            productHooks={productHooks} 
            detailToggle={detailToggle}
            changeDetailToggle={()=>detailToggoleEvent()}
        />

        {
            config?.shortName === "bellewholesale" && (customer?.isDropShipper || customer?.isWholesaler) && 
            <DownloadProductImages 
                productVO={productVO} 
                selectedProduct={selectedProduct} 
            />
        }

        {
            isBeautyMakeup && <BeautyIngredients selectedProduct={selectedProduct} />
        }
    </div>
}

export default ProductDetailAndModel;